<template>
	<div>
		<div class="content">

			<section class="paragraph">
				<h2>Una linea completa per le tue creazioni</h2>
				<p>Da più di un secolo <b>Perugina®</b> è sinonimo di alta qualità ed è simbolo dell’arte cioccolatiera italiana. Grande attenzione viene dedicata alla scelta del cacao e delle materie prime e, grazie alla creatività e alla passione dei Maestri Cioccolatieri Perugina, ogni creazione è un piccolo capolavoro di gusto, unico e inimitabile. I prodotti Perugina sono tantissimi e tutti incontrano il consenso dei palati più diversi: dalla nuova linea <b>Perugina® GranBlocco</b> ai grandi classici <b>Perugina® Cacao</b> e Perugina® Gocce le scelte sono vaste, tutte sotto il comun denominatore dell'alta qualità per fare di ogni creazione un capolavoro di gusto.</p>

				<h2>Cos'è Perugina® GranBlocco</h2>
				<p>Una linea di blocchi ideali per esprimere al massimo la propria creatività. Perugina® GranBlocco è <b>100% cioccolato di qualità</b> dal gusto unico: Perugina® GranBlocco Fondente Extra 50% è il perfetto equilibrio del cioccolato fondente adatto a tutte le creazioni, Perugina® GranBlocco Fondente Extra 70% è inteso ed avvolgente per ricette con grande personalità. Grazie alle diverse percentuali di cacao è possibile ideare ricette innovative e realizzare preparazioni dal gusto sorprendente, sia dolci che salate.</p>

			</section>

		</div>

		<div class="banner">
			<div class="banner-inner" :style="style">
			</div>
		</div>
		<div class="content">

			<section class="paragraph">

				<h2>Il cacao Perugina</h2>
				<p>Con Perugina® Cacao potete stupire in cucina. Dal gusto inconfondibile e adatto a diverse ricette, da utilizzare come ingrediente o come guarnizione, è capace di cambiare un piatto dandogli una personalità unica. Se Perugina® <b>Cacao Amaro</b> regala un gusto avvolgente, Perugina® <b>Cacao Extra Dark</b> ha un sapore intenso e persistente. Si adatta alle preparazioni più sofisticate, essendo anche un ingrediente ottimo per cucinare. Dal colore scuro ed estremamente duttile, garantisce infatti una resa eccellente.</p>

				<h2>Cucina con il cioccolato Perugina</h2>
				<p>Il cioccolato Perugina, così come il cacao, aggiunge un tocco in più ai dolci, ma anche ai piatti salati. Le ricette <b>col cioccolato Perugina</b> mirano a esaltare il connubio tra questo ingrediente e il salato, facendo scoprire nuovi sapori e nuove combinazioni. Il tutto tenendo sempre a mente i principi della dieta mediterranea per offrire un’alimentazione genuina ed equilibrata.</p>
			</section>

			<slot name="slider">
			</slot>

			<slot name="button">
			</slot>

		</div>

	</div>
</template>
<script>

export default {
	computed: {
		style () {
			return {
				background: 'url(' + require('../../assets/img/perugina/cacao_1600.jpg') + ') 50% 70% no-repeat',
				backgroundSize: 'cover'
			}
		}
	}
}
</script>

<style scoped>

.content {
	max-width: 800px;
}

.paragraph p {
	margin-bottom: 45px;
}

.logos {
	margin: 20px 0;
}

.banner {
	width: 100%;
	max-height: 400px;
	height: 0px;
	max-width: 100%;
	overflow: hidden;
	padding-bottom: 30%;
	position: relative;
	margin-bottom: 40px;
}

.banner-inner {
	height: 100%;
	width: 100%;
	position: absolute;
	overflow: hidden;
}

@media (max-width: 800px) {
	.banner {
		padding-bottom: 50%;
	}
}
</style>
